(() => {
  const PREORDER_LABEL = "予約商品をカートに追加";
  const marker = document.querySelector('[data-sk-p2s-buybox-pilot="decision"]');

  if (!marker) {
    return;
  }

  const productInfo = marker.closest(".product-info");
  if (!productInfo) {
    return;
  }

  productInfo.classList.add("sk-p2s-buybox-active");

  function relabelPreorderButton() {
    const preorderBadge = productInfo.querySelector(
      '[id^="SkStockBadge-"] .sk-stock-badge--pre',
    );
    const addButton = productInfo.querySelector(".button-add-to-cart");
    const label = addButton?.querySelector("span");

    if (!preorderBadge || !addButton || !label || addButton.disabled) {
      return;
    }

    if (label.textContent.trim() !== PREORDER_LABEL) {
      label.textContent = PREORDER_LABEL;
    }

    addButton.dataset.skExperiment = "p2s-buybox-v1";
    addButton.dataset.skVariant = "after";
  }

  function positionTrustStrip() {
    const trustStrip = productInfo.querySelector(
      '[data-sk-p2s-buybox-pilot="after-cta"]',
    );
    const productActions = productInfo.querySelector(".product-actions");

    if (!trustStrip || !productActions || trustStrip.parentElement === productActions) {
      return;
    }

    productActions.append(trustStrip);
  }

  // 「よく一緒に購入」(Selleasy)は折りたたまず常時表示する（2026-07-27 Sho指示）。
  // 旧foldFrequentlyBoughtTogether()は削除。CTAより下に位置するため、常時表示でも
  // 購入ボタンの位置は変わらない。

  function annotateMobileProductBar() {
    const bar = document.querySelector(".sk-mobile-product-bar");
    const meta = bar?.querySelector(".sk-mobile-product-bar__meta");
    const preorderBadge = productInfo.querySelector(
      '[id^="SkStockBadge-"] .sk-stock-badge--pre',
    );
    let status = bar?.querySelector(".sk-p2s-mobile-product-bar__status");

    if (!bar || !meta) {
      return;
    }

    if (!preorderBadge) {
      status?.remove();
      return;
    }

    if (!status) {
      status = document.createElement("span");
      status.className = "sk-p2s-mobile-product-bar__status";
      meta.append(status);
    }

    status.textContent = "予約販売・入荷時期確認中";

    // 固定バーのボタンも本体CTAと同じ意味に揃える。
    // 押せる状態（PreOrder Now有効）なのに「入荷待ち」表示だと買えないように見えるため。
    const barButton = bar.querySelector("button, .button");
    const barLabel = barButton?.querySelector("span") || barButton;
    if (barButton && !barButton.disabled && barLabel && barLabel.textContent.includes("入荷待ち")) {
      barLabel.textContent = "予約する";
    }
  }

  // 無償のメーカー1年保証を有償延長(Proteger)の前に明示する。
  // これが無いと「保証=有料¥16,280〜」に読める（2026-07-27 監査指摘）。
  function insertWarrantyNote() {
    const offer = productInfo.querySelector("#proteger-offer");
    if (!offer || offer.parentElement.querySelector(".sk-p2s-warranty-note")) {
      return;
    }

    const note = document.createElement("p");
    note.className = "sk-p2s-warranty-note";
    note.textContent = "国内1年保証つき。さらに延長する場合は以下から選べます。";
    offer.before(note);
  }

  function enhance() {
    relabelPreorderButton();
    positionTrustStrip();
    annotateMobileProductBar();
    insertWarrantyNote();
  }

  let framePending = false;
  const observer = new MutationObserver(() => {
    if (framePending) {
      return;
    }

    framePending = true;
    window.requestAnimationFrame(() => {
      framePending = false;
      enhance();
    });
  });

  observer.observe(productInfo, {
    childList: true,
    subtree: true,
  });

  document.addEventListener("product:variant-change", enhance);
  enhance();
  window.setTimeout(enhance, 500);
  window.setTimeout(enhance, 1500);
  window.setTimeout(enhance, 3000);
  window.setTimeout(enhance, 6000);
  window.setTimeout(() => observer.disconnect(), 15000);
})();
